import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import ToolbarMenu from './ToolbarMenu';
import styles from '../styles.module.css';
import ToolButton from './ToolButton';
import WhiteboardController from '../controllers/WhiteboardController';
import classNames from 'classnames';

// Stylus toolbar sub-menu for choosing a stamp.
const StampMenu = () => {
  const controller = useController(WhiteboardController);
  const { shapeDragManager } = controller;

  return (
    <ToolbarMenu columns={4} columnWidth={56}>
      {controller.stampStyluses.map((stylusGroup, groupNum) => {
        return (
          <React.Fragment key={groupNum}>
            {groupNum !== 0 && (
              <hr
                key={groupNum}
                style={{
                  width: '100%',
                  border: '1px solid var(--theme-light-border)',
                }}
              />
            )}
            {stylusGroup.map((stylus, i) => (
              <ToolButton
                className={classNames(
                  styles.toolButton,
                  styles['toolButton--stamp']
                )}
                key={`${groupNum}-${i}`}
                draggable={true}
                onDragStart={e => shapeDragManager.startDrag(e, stylus)}
                onClick={event => {
                  controller.actionSetStylus(stylus);
                  controller.actionSetStylusMenu(null);
                  event.stopPropagation();
                }}
              >
                {stylus.renderEmoji()}
              </ToolButton>
            ))}
          </React.Fragment>
        );
      })}
    </ToolbarMenu>
  );
};

export default ApplicationView(StampMenu);
